<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-input size="medium" v-model="searchForm.name" placeholder="请输入角色名称"  @keyup.enter.native="getTableList"></el-input>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
    </div>
    <div class="searchRight">
      <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">增加</el-button>
    </div>
   </div>
   <el-table
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="roleName"
      label="角色名称">
    </el-table-column>
    <el-table-column
      prop="roleCode"
      label="角色标识">
    </el-table-column>
    <el-table-column
      label="是否可删">
      <template slot-scope="scope">
        <div v-if="scope.row.id!=1">
          <el-switch
          @change="ChangeTypeIsDel(scope.row)"
          v-model="scope.row.isDelCheck"
          active-color="#67c23a"
          inactive-color="#999">
          </el-switch>
          <span v-if="!scope.row.isDelCheck" class="switchTxt">不可删除</span>
          <span v-else class="switchActiveTxt">可删除</span>
        </div>
        <div v-else style="color:#999">--</div>
      </template>
    </el-table-column>
    <el-table-column
      prop="way"
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="editType(scope.row)"><i class="el-icon-edit" style="margin-right:3px;"></i>修改</el-button>
        <el-button size="mini" type="danger" @click="deleteType(scope.row)" v-if="scope.row.isDelCheck&&scope.row.id!=1"><i class="el-icon-delete" style="margin-right:3px;"></i>删除</el-button>
      </template>
    </el-table-column>
  </el-table>
    <el-dialog
    :title="ruleForm.id!=''?'编辑':'新增'"
    :visible.sync="dialogVisible"
    width="440px">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="角色名称" prop="name" :rules="rules.name">
            <el-input placeholder="请输入角色名称" v-model="ruleForm.name" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="角色标识" prop="code" :rules="rules.code">
            <el-input placeholder="请输入角色标识" v-model="ruleForm.code" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="是否可删除" prop="isDel">
            <el-radio-group v-model="ruleForm.isDel">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkName = (rule, value, callback) => {
      let reg = new RegExp("^[A-Za-z0-9\u4e00-\u9fa5]+$");
      if (!value) {
        return callback(new Error('请输入角色名称'));
      } else if (!reg.test(value)) {
        return callback(new Error('只支持中文、英文、数字'));
      } else if (value.length<2||value.length>20) {
        return callback(new Error('长度在 2 到 20 个字符'));
      } else {
        callback();
      }
    }
    var checkCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入英文标识"));
      } else {
        const reg = /^[0-9a-zA-Z]+$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("只能输入英文、数字"));
        }
      }
    };
    return {
      searchForm:{
        name:'',
      },
      tableData: [],
      dialogVisible:false,
      ruleForm:{
          name:'',
          isDel:'',
          id:'',
          code:''
      },
      rules:{
          name: [
              { required: true, validator: checkName, trigger: 'blur' }
          ],
          code:[
              { required: true, validator: checkCode, trigger: 'blur' }
          ],
          isDel:[
              { required: true, message: '请选择是否可删除', trigger: 'change' }
          ]
      }
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
            if (valid) {
                let res = await this.$http.addRole({...this.ruleForm});
                if (res) {
                  this.$message.success('操作成功！');
                  this.dialogVisible=false;
                  this.getTableList()
                }
            } else {
            console.log('error submit!!');
            return false;
            }
        });
    },
    deleteType(row){
        this.$confirm(`确定要删除${row.roleName}角色吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$http.delRole({ids:row.roleId});
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
                
        });
    },
    editType(row){
        this.ruleForm.id=row.roleId;
        this.ruleForm.name=row.roleName;
        this.ruleForm.code=row.roleCode;
        this.ruleForm.isDel=Number(row.roleIsDel);
        this.dialogVisible=true
    },

    addFunc(){
        this.ruleForm.id='';
        this.ruleForm.name='';
        this.ruleForm.code='';
        this.dialogVisible=true;
    },
    async getTableList(val){
       let res = await this.$http.roleList({...this.searchForm});
        if (res) {
        this.tableData=res.list.map(x=>{
            if(x.roleIsDel==2){
              x.isDelCheck=true
            } else {
              x.isDelCheck=false
            }
            return x
        })
        }
    },
    async ChangeTypeIsDel(row){
        let res = await this.$http.updateRoleIsDel({id:row.roleId,isDel:row.isDelCheck?2:0});
        if (res) {
        this.$message.success('操作成功！');
        this.getTableList()
        }
    },
  }
};
</script>

<style scoped>


</style>
